import TableCell from "../../../table/TableCell";
import LoadingMoire from "../../../LoadingMoire";
import $ from "jquery";

export default class LoadingCell extends TableCell {
    constructor(rowObj) {
        super(null, rowObj);
    }

    toggleLoading(loading) {
        if (!this.loadingMoire)
            this.loadingMoire = new LoadingMoire().init(this.$cell)
        if (loading)
            this.loadingMoire.show()
        else
            this.loadingMoire.hide()
    }

    updateUI() {}
    updateCell() {}
    writeContent() {
        this.$cell = $(this.getCellEl());
        this.$cell.addClass('loadingCell');
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/tabularDataTable/LoadingCell.js